import React, { useState, useEffect } from 'react';

import { useWithdrawalsForClient } from '../../models/useWithdrawalsForClient';
import CenteredSpinner from '../CenteredSpinner';

import { WithdrawalsList } from './BankAccountComponents';

const InlineWithdrawalsHistory = ({ clientId, isAdmin = false, highlightWithdrawalId }) => {
  const [withdrawals, loading] = useWithdrawalsForClient(clientId, isAdmin);
  const [expandedIds, setExpandedIds] = useState(new Set());

  // Auto-expand highlighted withdrawal
  useEffect(() => {
    if (highlightWithdrawalId) {
      setExpandedIds(new Set([highlightWithdrawalId]));
    }
  }, [highlightWithdrawalId]);

  const toggleExpanded = (withdrawalId) => {
    setExpandedIds(prevExpandedIds => {
      const newExpandedIds = new Set(prevExpandedIds);
      if (newExpandedIds.has(withdrawalId)) {
        newExpandedIds.delete(withdrawalId);
      } else {
        newExpandedIds.add(withdrawalId);
      }
      return newExpandedIds;
    });
  };

  if (loading) {
    return <CenteredSpinner loading={true} noLayout={true} />;
  }

  return (
    <WithdrawalsList 
      withdrawals={withdrawals} 
      clientId={clientId} 
      isAdmin={isAdmin} 
      highlightWithdrawalId={highlightWithdrawalId}
      expandedIds={expandedIds}
      onToggleExpanded={toggleExpanded}
    />
  );
};

export default InlineWithdrawalsHistory;

